export const isEmpty = (obj: any): boolean => {
    if (typeof obj !== 'object' && typeof obj !== 'string') {
        return true;
    }

    return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
